import { formatPrice } from '@/services/formatter';
import { getRecordWordForm } from '@/services/helpers/strings';

import type { TLeasingOrderDetailed, TLeasingSubject } from '../../../types';

export const getLeasingDraftKey = (uuid: string) => `leasing_draft_${uuid}`;

export const getLeasingVehicleFormKey = (userUuid: string, requestId: string) =>
  `leasing_vehicle_${userUuid}_${requestId}`;

export type TAutoSubjectView = {
  id: string;
  lineTotal: string;
  quantityLabel: string;
  title: string;
};

const getCarsCountLabel = getRecordWordForm.bind(null, [
  'автомобилей',
  'автомобиль',
  'автомобиля',
  'автомобилей'
]);

const getSubjectTitle = (subject: TLeasingSubject): string => {
  const carName = [
    subject.brand?.name,
    subject.model?.name,
    subject.equipmentName
  ]
    .filter(Boolean)
    .join(' ');
  const year = subject.year ? String(subject.year) : '';
  const withYear = [carName, year].filter(Boolean).join(', ');

  return [withYear, subject.engineType?.name].filter(Boolean).join(' · ');
};

export const getAutoInfo = (
  request: TLeasingOrderDetailed | null
): {
  amount: string;
  label: string;
  subjects: TAutoSubjectView[];
} => {
  const leasingSubjects = request?.leasingSubjects ?? [];
  const carsCount = leasingSubjects.reduce(
    (sum, subject) => sum + (subject.quantity || 0),
    0
  );
  const subjectsTotal = leasingSubjects.reduce(
    (sum, subject) => sum + (subject.cost || 0) * (subject.quantity || 0),
    0
  );
  const amountValue =
    leasingSubjects.length > 0
      ? subjectsTotal
      : Number(request?.totalAmount ?? 0);

  return {
    amount: formatPrice(amountValue),
    label: carsCount > 0 ? getCarsCountLabel(carsCount) : '',
    subjects: leasingSubjects.map((subject, index) => ({
      id: subject.uuid || String(index),
      lineTotal: `${formatPrice((subject.cost || 0) * (subject.quantity || 0))} ₸`,
      quantityLabel: `${subject.quantity || 0} × ${formatPrice(subject.cost || 0)} ₸`,
      title: getSubjectTitle(subject)
    }))
  };
};
